"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4229],{

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 41208:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var SUCCESS_MESSAGE = {
    ALERT_GREEN: "alert-green",
    SNACKBAR_GREEN: "snackbar-green",
    PROFILE_UPDATED: "Profile Updated",
    POST_SUCCESSFUL: "Post successful",
    REPOST_SUCCESSFUL: "Post Reposted",
    REPLY_SUCCESSFUL: "Post reply successful!",
    SET_TOP_SUCCESSFUL: "Set as Top successful!",
    REMOVE_TOP_SUCCESSFUL: "Remove as Top successful!",
    RESET_TOP_SUCCESSFUL: "Reset as Top successful!",
    UNTAG_POST_SUCCESSFUL: "Untag Post Topic Success",
    PASSWORD_CHANGED: "Password changed",
    USER_BLOCKED: "User blocked",
    USER_UNBLOCKED: "User unblocked",
    CHANGE_NUMBER_SUCCESSFUL: "Phone number changed!",
    SAVE_TEMPLATE_SUCCESS: "Success save template",
    POST_SHARED_SUCCESSFUL: "Post Shared",
    EVENT_SHARED_SUCCESSFUL: "Event Shared",
    POST_PINNED_SUCCESSFUL: "Post successfully pinned",
    POST_UNPINNED_SUCCESSFUL: "Post successfully unpinned",
    POST_SUCCESSFUL_UPDATE: "Post successfully updated",
    POST_SUCCESSFUL_DELETED: "Successfully deleted",
    SCREENER_TEMPLATE_DELETED: "Screener Template Deleted",
    FACEBOOK_CONNECTED: "Facebook connect successful",
    GOPAY_CHANGED: "Nomor gopay anda berhasil diubah",
    REPORT_DELIVERED: "Report has been delivered",
    UPDATE_GROUP_PHOTO_SUCCESSFUL: "Group Photo Updated",
    DELETE_STREAM_MULTIPLE_SUCCESSFUL: "Success delete stream",
    FINANCIAL_COLUMN_DELETED: "Financial Column Deleted"
};
/* harmony default export */ __webpack_exports__["Z"] = (SUCCESS_MESSAGE);


/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref, ref1;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data
    };
};


/***/ }),

/***/ 25516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 50%;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var UIIconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var IconWrapper = (0,styled_components_browser_esm["default"])(UIIconWrapper).withConfig({
    componentId: "sc-2b178c34-0"
})(_templateObject(), ui/* color.primary */.$_.primary);
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/AlertErrorMessage/index.js
/* eslint-disable max-len */ // ant design






var Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Flex = ui/* Common.Flex */.Gn.Flex;
/**
 * handleErrorMessageAPI to activate message
 * @param {string} content
 * @param {string} type - "alert-green" | "alert-red" | "alert-orange" | "alert-blue" | "snackbar-green" | "plain-green"
 * @param {=boolean} hasCloseIcon
 */ var handleErrorMessageAPI = function(content, type) {
    var hasCloseIcon = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,app/* isClient */.C5)()) return null;
    // destroy last message alert
    message/* default.destroy */.ZP.destroy();
    var Icon = null;
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/alert-close.svg",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    }) : null;
    if (type === "alert-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                size: "14px",
                className: "icon-toolbar_check",
                color: ui/* color.light */.$_.light
            })
        });
    } else if (type === "snackbar-green") {
        Icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/alert-success.svg"
        });
    }
    // show alert
    message/* default.open */.ZP.open({
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: type,
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: content
                    }),
                    closeIcon
                ]
            })
        }),
        duration: 3,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0,
            maxWidth: "320px"
        },
        className: "sysmsg-content",
        onClick: function() {
            return message/* default.destroy */.ZP.destroy();
        }
    });
};
/* harmony default export */ var AlertErrorMessage = (handleErrorMessageAPI);


/***/ }),

/***/ 14229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44252);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51346);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);





function getToken() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx]) : null;
    var accessTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0]), 10) : null;
    var refreshToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4]) : null;
    var refreshTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessTokenExp.toString());
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
}
function destroyToken() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__/* .localStorageOrderbookHandler.remove */ .Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && localStorage && localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(intercom);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings
});


/***/ }),

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ isMobileVersion; },
/* harmony export */   "C9": function() { return /* binding */ getLastSlashURL; },
/* harmony export */   "CB": function() { return /* binding */ convertTimeZone; },
/* harmony export */   "Ex": function() { return /* binding */ saveObject; },
/* harmony export */   "FD": function() { return /* binding */ emptyObject; },
/* harmony export */   "GD": function() { return /* binding */ convertToEventValue; },
/* harmony export */   "Gf": function() { return /* binding */ sanitizeHTMLTags; },
/* harmony export */   "OB": function() { return /* binding */ decodeBase64ToJS; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "TE": function() { return /* binding */ copyTextToClipboard; },
/* harmony export */   "Tk": function() { return /* binding */ handleErrorAvatar; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hB": function() { return /* binding */ popupWindowToCenter; },
/* harmony export */   "hr": function() { return /* binding */ escapeRegExp; },
/* harmony export */   "k6": function() { return /* binding */ convertToSlug; },
/* harmony export */   "ko": function() { return /* binding */ replaceAll; },
/* harmony export */   "lz": function() { return /* binding */ sanitizeURL; },
/* harmony export */   "me": function() { return /* binding */ encodeBase64FromJS; },
/* harmony export */   "pV": function() { return /* binding */ getColorBasedOnNumber; },
/* harmony export */   "r$": function() { return /* binding */ capitalizer; },
/* harmony export */   "rK": function() { return /* binding */ transformAvatarUrl; }
/* harmony export */ });
/* unused harmony exports sortAlpha, decodeHtml, getAreaTimeZone, setCharAt, timeZoneConvert, newlineToBr, getPathFromUrl, trimText */
/* harmony import */ var js_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52300);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25516);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76825);
/* eslint-disable no-restricted-syntax */ /* eslint-disable indent */ /* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-nested-ternary */ /* eslint-disable wrap-iife */ 





/* eslint-disable import/prefer-default-export */ var copyTextToClipboard = function(text) {
    var customAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    var body = document.querySelector("body");
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand("copy");
    body.removeChild(input);
    if (customAlert) {
        customAlert();
    } else {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("Link copied", constants_successMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
    }
};
function isMobileVersion() {
    var check = false;
    // eslint-disable-next-line func-names
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function popupWindowToCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(url, title, "scrollbars=yes, width=".concat(w, ", height=").concat(h, ", top=").concat(top, ", left=").concat(left));
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
function getLastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function handleErrorAvatar(e, paramUsername) {
    var fallbackUrl = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O, "/images/avatar.png");
    e.target.onerror = null;
    e.target.src = fallbackUrl;
}
function parsePureValueSep(pv) {
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i -= 1){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            result = parsePureValueSep(raw[0]);
            result = raw[1] && raw[1] !== "K" ? "".concat(result, " ").concat(raw[1]) : result;
            if (raw[1] === "K") {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result);
            }
        } else {
            result = number;
        }
    }
    return result;
};
function sortAlpha(a, b) {
    var ax = a.toLowerCase();
    var bx = b.toLowerCase();
    return ax < bx ? -1 : ax > bx ? 1 : 0;
}
/**
 * Convert data to event change data to be used in `useForm` hooks
 * @param {*} val
 * @returns {Object}
 */ var convertToEventValue = function(val) {
    var data = {
        target: {
            value: val
        }
    };
    return data;
};
/**
 * Decode string to html text area
 * @param {string} html
 * @return {string}
 */ function decodeHtml(html) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
}
/**
 * Convert text to slug
 * @param {string} text
 * @return {string}
 */ function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
/**
 * Capitalize
 * @param {string} string
 * @return {string}
 */ function capitalizeFirstLetter(string) {
    if (!string) return string;
    var newString = string.toLowerCase();
    return newString.charAt(0).toUpperCase() + newString.slice(1);
}
function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
}
/**
 * Capitalizer
 * @param {string} string
 * @param {number} at
 * @return {string}
 */ function capitalizer(string) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!string) return string;
    var upperCasedLetter = string.charAt(at).toUpperCase();
    return setCharAt(string, at, upperCasedLetter);
}
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.encode */ .DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64__WEBPACK_IMPORTED_MODULE_0__/* .Base64.decode */ .DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
/**
 * Get time zone string that is consumed by moment.js function
 * @param {string} country
 * @returns {string}
 */ function getAreaTimeZone(country) {
    var zone = "";
    switch(country){
        case "ID":
            zone = "Asia/Jakarta";
            break;
        case "MY":
            zone = "Asia/Kuala_Lumpur";
            break;
        case "SG":
            zone = "Asia/Singapore";
            break;
        default:
            zone = "Asia/Jakarta";
            break;
    }
    // return 'Africa/Cairo'
    return zone;
}
/**
 * Convert time based on format passed down
 * @param {
 *   Object {
 *     datetime: string,
 *     zone: string,
 *     oldFormat: string,
 *     newFormat: string
 *   }
 * } props - properties for moment.js
 * @returns
 */ function timeZoneConvert(param) {
    var datetime = param.datetime, zone = param.zone, oldFormat = param.oldFormat, newFormat = param.newFormat;
    var format = newFormat;
    if (!newFormat) {
        format = oldFormat;
    }
    var datetimeUtc = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(datetime, oldFormat).utc().format();
    if (!moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(datetimeUtc).isValid()) {
        return datetime;
    }
    return moment_timezone__WEBPACK_IMPORTED_MODULE_1___default().tz(datetimeUtc, zone).format(format);
}
/**
 * Convert time using moment.js
 * @param {string} datetime
 * @param {string=} country
 * @param {string=} newformat
 * @param {string=} oldformat
 * @returns {string}
 */ function convertTimeZone(datetime, country, newformat, oldformat) {
    var newFormat = "DD MMM YY, HH:mm";
    var oldFormat = "YYYY-MM-DD HH:mm:ss";
    if (newformat) {
        newFormat = newformat;
    }
    if (oldFormat) {
        oldFormat = oldformat;
    }
    var zone = getAreaTimeZone(country);
    var lastMessageDate = timeZoneConvert({
        datetime: datetime,
        zone: zone,
        oldFormat: oldFormat,
        newFormat: newFormat
    });
    return moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(lastMessageDate).isValid() ? lastMessageDate : datetime;
}
/**
 * Turn newline into <br/>
 * @param {string} str
 * @param {string=} isXhtml
 * @returns {string}
 */ function newlineToBr(str, isXhtml) {
    var breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br />" : "<br>";
    return "".concat(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1".concat(breakTag, "$2"));
}
function emptyObject(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
function replaceAll(str, match, replacement) {
    return str.replace(new RegExp(escapeRegExp(match), "g"), function() {
        return replacement;
    });
}
var getColorBasedOnNumber = function(number) {
    if (Number(number) > 0) return _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__/* .color.primary */ .$_.primary;
    if (Number(number) < 0) return _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__/* .color.sunsetOrange */ .$_.sunsetOrange;
    return _stockbit_ui__WEBPACK_IMPORTED_MODULE_5__/* .color.highempahis */ .$_.highempahis;
};
function getPathFromUrl(url) {
    return url.split("?")[0];
}
function trimText(description, maxLength) {
    var trimmedString = description.substr(0, maxLength);
    var lastStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
    trimmedString = trimmedString.substr(0, lastStringIndex);
    if (description.length > maxLength) {
        trimmedString += "...";
    }
    return trimmedString;
}
var transformAvatarUrl = function() {
    var avatarUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (avatarUrl.startsWith("http")) {
        return avatarUrl;
    }
    return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .AVATAR_URL */ .q$, "/").concat(avatarUrl);
};
/**
 * sanitizeHTMLTags
 * Remove Curve Brackets from string
 * to prevent xss, security issues
 *
 * This function is created because regex "/(<([^>]+)>)/gi" that already
 * used in v2 is not accepted in sonar-scan v3.
 * This function already have unit test
 * to makesure the result same as the previous regex implementation.
 * @param {String} originalString
 * @returns
 */ var sanitizeHTMLTags = function() {
    var originalString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var result = "";
    var start = 0;
    while(true){
        var startBracket = originalString.indexOf("<", start);
        if (startBracket === -1) break;
        var endBracket = originalString.indexOf(">", startBracket);
        if (endBracket === -1) break;
        if (endBracket - startBracket === 1) {
            result += originalString.substring(startBracket - (startBracket - start), endBracket + 1);
        } else {
            result += originalString.substring(start, startBracket);
        }
        start = endBracket + 1;
    }
    result += originalString.substring(start);
    return result;
};
function sanitizeURL() {
    var urlToCheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    if (urlToCheck[0] === "/") {
        return urlToCheck;
    }
    try {
        var safeProtocol = [
            "https",
            "http"
        ];
        var safeHost = [
            "stockbit.com",
            "ui.lab.stockbit.com",
            "itunes.apple.com",
            "play.google.com", 
        ];
        var url = new URL(urlToCheck);
        if (safeProtocol.indexOf(url === null || url === void 0 ? void 0 : url.protocol) < 0) {
            throw Error("Not safe protocol: ".concat(url === null || url === void 0 ? void 0 : url.protocol));
        }
        if (safeHost.indexOf(url === null || url === void 0 ? void 0 : url.host) < 0) {
            throw Error("Not safe host: ".concat(url === null || url === void 0 ? void 0 : url.host));
        }
        return urlToCheck;
    } catch (err) {
        console.error(err);
        return constants_api__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    }
}



/***/ })

}]);